import { Injectable } from '@angular/core';

declare let gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor() {}

  public eventEmitter(eventName: string, options?: object) {
    gtag('event', eventName, { ...options });
  }
}
